module.exports = __webpack_public_path__ + "img/reading-title.572b8791.png";